if (!customElements.get('quick-add-modal')) {
	customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
		constructor() {
			super();
			this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
		}

		hide(preventFocus = false) {
			const cartDrawer = document.querySelector('cart-drawer');
			if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
			this.modalContent.innerHTML = '';
			if (preventFocus) this.openedBy = null;
			super.hide();
		}

		show(opener) {
			opener.setAttribute('aria-disabled', true);
			opener.classList.add('loading');

			const spinner = opener.querySelector('.loading-overlay__spinner');
			if (spinner) spinner.classList.remove('hidden');

			const productUrl = opener.getAttribute('data-product-url');
			const openerIntensity = Number(opener.getAttribute('data-product-intensity') || 0);

			fetch(productUrl + '.js')
				.then((r) => r.json())
				.then((product) => {
					this.renderQuickView(product, productUrl, openerIntensity);
					super.show(opener);
				})
				.catch((err) => {
					console.error('Quick-view fetch failed', err);
				})
				.finally(() => {
					opener.removeAttribute('aria-disabled');
					opener.classList.remove('loading');
					if (spinner) spinner.classList.add('hidden');
				});
		}

		renderQuickView(product, productUrl, openerIntensity) {
			const variant = product.variants[0] || {};
			const image = (product.featured_image) ||
				(product.images && product.images[0]) || '';
			const intensityFromProduct = Number((product.metafields && product.metafields.custom && product.metafields.custom.intensity && product.metafields.custom.intensity.value) || 0);
			const intensity = Math.max(0, Number.isFinite(intensityFromProduct) && intensityFromProduct > 0 ? intensityFromProduct : openerIntensity);

			let badgeTag = null;
			if (product.tags) {
				const tags = Array.isArray(product.tags) ? product.tags : product.tags.split(',').map(function(t) { return t.trim(); });
				for (var i = 0; i < tags.length; i++) {
					var t = tags[i].toLowerCase();
					if (t === 'best-seller' || t === 'bestseller') { break; }
					if (t === 'new') { badgeTag = 'new'; break; }
				}
			}

			const price = variant.price ? (variant.price / 100).toFixed(2) : product.price ? (product.price / 100).toFixed(2) : '0.00';
			const firstOptionValue = variant.option1 || '';
			const desc = product.description ? product.description.replace(/<[^>]*>/g, '') : '';
			const descTruncated = desc.length > 200 ? desc.substring(0, 200) + '…' : desc;

			const badgeHtml = badgeTag === 'new'
				? '<span class="qv__badge">New</span>'
				: '';

			const imgHtml = image
				? '<img src="' + image + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" width="700" height="700" loading="eager">'
				: '';

			const disabled = variant.available === false;

			const html = ''
				+ '<div class="qv">'
				+   '<div class="qv__image">'
				+     badgeHtml
				+     imgHtml
				+   '</div>'
				+   '<div class="qv__info">'
				+     '<div>'
				+       '<div class="qv__header">'
				+         '<h2 class="qv__title">' + (product.title || '') + '</h2>'
				+         '<p class="qv__vendor">' + (product.vendor || '') + '</p>'
				+       '</div>'
				+       (descTruncated ? '<p class="qv__description">' + descTruncated + '</p>' : '')
				+       '<div class="qv__intensity">'
				+         '<span class="qv__intensity-label">Интензивност:</span>'
				+         '<span class="qv__intensity-value">' + intensity + '</span>'
				+       '</div>'
				+     '</div>'
				+     '<div>'
				+       '<div class="qv__price-row">'
				+         '<span class="qv__price">' + price + ' €</span>'
				+       '</div>'
				+       '<product-form class="qv__product-form" data-hide-errors="true" data-source="quickview">'
				+         '<form action="/cart/add" method="post" data-type="add-to-cart-form">'
				+           '<input type="hidden" name="id" value="' + variant.id + '">'
				+           '<input type="hidden" name="quantity" value="1">'
				+           '<button type="submit" name="add" class="qv__add-btn"' + (disabled ? ' disabled aria-disabled="true"' : '') + '>'
				+             '<svg class="icon-cart" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" fill="none" width="16" height="16"><path d="M3.25 6V4.5C3.25 3.50544 3.64509 2.55161 4.34835 1.84835C5.05161 1.14509 6.00544 0.75 7 0.75C7.99456 0.75 8.94839 1.14509 9.65165 1.84835C10.3549 2.55161 10.75 3.50544 10.75 4.5V6H13C13.1989 6 13.3897 6.07902 13.5303 6.21967C13.671 6.36032 13.75 6.55109 13.75 6.75V15.75C13.75 15.9489 13.671 16.1397 13.5303 16.2803C13.3897 16.421 13.1989 16.5 13 16.5H1C0.801088 16.5 0.610322 16.421 0.46967 16.2803C0.329018 16.1397 0.25 15.9489 0.25 15.75V6.75C0.25 6.55109 0.329018 6.36032 0.46967 6.21967C0.610322 6.07902 0.801088 6 1 6H3.25ZM3.25 7.5H1.75V15H12.25V7.5H10.75V9H9.25V7.5H4.75V9H3.25V7.5ZM4.75 6H9.25V4.5C9.25 3.90326 9.01295 3.33097 8.59099 2.90901C8.16903 2.48705 7.59674 2.25 7 2.25C6.40326 2.25 5.83097 2.48705 5.40901 2.90901C4.98705 3.33097 4.75 3.90326 4.75 4.5V6Z" fill="currentColor"/></svg>'
				+             'Добави в количката'
				+           '</button>'
				+         '</form>'
				+       '</product-form>'
				+       '<a class="qv__details-link" href="' + productUrl + '">Виж пълни детайли →</a>'
				+     '</div>'
				+   '</div>'
				+ '</div>';

			this.modalContent.innerHTML = html;

			this.modalContent.querySelectorAll('script').forEach(function(old) {
				var s = document.createElement('script');
				Array.from(old.attributes).forEach(function(a) { s.setAttribute(a.name, a.value); });
				s.appendChild(document.createTextNode(old.innerHTML));
				old.parentNode.replaceChild(s, old);
			});
		}
	});
}
